import config from './config';

const amountOptions = [25, 50, 75, 100, 150, 200];

const giftCard = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /**
       * Used to control whether we want to display gift card form or not in checkout flow.
       */
      isDisplayingCheckoutGiftCard: true,
      /** The number of characters replaced by '*' for applied gift cards. */
      numberOfMaskedCharacters: 15,

      /**
       * Used to control whether we want to display gift card purchase CTA in the Gift
       * Card Landing Page: /gift-cards.
       */
      isPurchaseAllowed: false,
      /**
       * Used to control whether we want to display the desktop title in the Gift Card
       * Landing Page: /giftcards.
       */
      canDisplayDesktopTitle: true,
      /**
       * Amount options for gift card purchase.
       */
      amountOptions,

      /**
       * Lower limit for gift card purchase amount.
       */
      lowerAmountLimit: 20,
      /**
       * Upper limit for gift card purchase amount.
       */
      upperAmountLimit: 1000,

      /**
       * Maximum length for the custom message.
       */
      maxMessageLength: 500,

      /**
       * Comma-separated list of product IDs that are valid gift cards and
       * should have tax-exempt status. Used to validate that only gift card
       * products are marked as tax-exempt. If a product is marked as tax-exempt
       * but NOT in this list, a warning will be logged.
       *
       * @example ['737872927738']
       * @example ['737872927738', '123456789']
       */
      validGiftCardProductIds: [] as Array<string>
    }
  },
  'AHNU-US': { default: { canDisplayDesktopTitle: false } },
  'TEVA-US': {
    default: {
      isPurchaseAllowed: true,

      // UPC / Product ID for Teva Gift Card product
      validGiftCardProductIds: ['737872927738']
    }
  },
  'UGG-US': {
    default: {
      isPurchaseAllowed: true,

      // UPC / Product ID for Teva Gift Card product
      validGiftCardProductIds: ['737872008291']
    }
  },
  'HOKA-US': {
    default: {
      isPurchaseAllowed: true,

      // UPC / Product ID for Teva Gift Card product
      validGiftCardProductIds: ['737872008017']
    }
  }
});

export default giftCard;
